// import {Col, Container, Nav, Row, Tab} from "@themesberg/react-bootstrap";
// import React, {useState} from "react";

// import DispenserNoNotAllocated from "./DispenserNoNotAllocated";
// import DispenserSrNoRecord from './DispenserSrNoRecord';
// import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
// import {faCogs} from "@fortawesome/free-solid-svg-icons";

// export default () => {
//   const [role, setRole] = useState(sessionStorage.getItem("role"));
//   return (
//     <article>
//       <Container className="px-0">
//         <Row className='d-flex flex-wrap flex-md-nowrap align-items-center py-4'>
//           <Col className="d-block mb-4 mb-md-0">
//             <h5 className="head mb-4">Dispenser Record View</h5>
//           </Col>
//         </Row>
//         <div>
//           <Tab.Container defaultActiveKey="dispenserSrNoRecord">
//             <Row>
//               <Col lg={12}>
//                 <Nav fill variant="pills" className="flex-column flex-sm-row">
//                   <Nav.Item>
//                     <Nav.Link
//                       eventKey="dispenserSrNoRecord"
//                       className="mb-sm-3 mb-md-0"
//                     >
//                       <FontAwesomeIcon icon={faCogs} className="me-2" />
//                       Dispenser Sr No Record
//                     </Nav.Link>
//                   </Nav.Item>
//                   <Nav.Item>
//                     <Nav.Link
//                       eventKey="dispenserNoNotAllocated"
//                       className="mb-sm-3 mb-md-0"
//                     >
//                       <FontAwesomeIcon icon={faCogs} className="me-2" />
//                       Dispenser No Not Allocated
//                     </Nav.Link>
//                   </Nav.Item>
//                 </Nav>
//                 <Tab.Content>
//                   <Tab.Pane eventKey="dispenserSrNoRecord" className="py-4">
//                     <DispenserSrNoRecord />
//                   </Tab.Pane>
//                   <Tab.Pane eventKey="dispenserNoNotAllocated" className="py-4">
//                     <DispenserNoNotAllocated />
//                   </Tab.Pane>
//                 </Tab.Content>
//               </Col>
//             </Row>
//           </Tab.Container>
//         </div>
//       </Container>

//     </article>
//   )
// }

import React from 'react'
import TicketnonTechDashboard from '../../pages/TicketServiceComp/TicketServiceDashboardComp/TicketnonTechDashboard'
const DispenserRecordTab = () => {
  return (
    <h4 className='m-auto text-center'>
<TicketnonTechDashboard/>
    </h4>
  )
}

export default DispenserRecordTab